<template>
  <div class="where-buy-tabs">
    <nav class="breadcrumbs" data-fade-in-top>
      <ul class="breadcrumbs__items breadcrumbs__items_barista" itemtype="https://schema.org/BreadcrumbList">
        <li class="breadcrumbs__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem"><a class="breadcrumbs__link" href="/" title="Главная" itemprop="item">Главная</a>
          <meta itemprop="position" content="0">
        </li>
        <li class="breadcrumbs__item" itemscope="itemscope" itemtype="http://data-vocabulary.org/Breadcrumb"><a class="breadcrumbs__link" href="#" aria-current="page" title="Где купить" itemprop="item">Где купить</a>
          <meta itemprop="position" content="1">
        </li>
      </ul>
      <ul class="breadcrumbs__items breadcrumbs__items_gm" itemtype="https://schema.org/BreadcrumbList">
        <li class="breadcrumbs__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem"><a class="breadcrumbs__link" href="/" title="Главная" itemprop="item">Главная</a>
          <meta itemprop="position" content="0">
        </li>
        <li class="breadcrumbs__item" itemscope="itemscope" itemtype="http://data-vocabulary.org/Breadcrumb"><a class="breadcrumbs__link" href="#" aria-current="page" title="Где купить" itemprop="item">Где купить</a>
          <meta itemprop="position" content="1">
        </li>
      </ul>
    </nav>
    <nav class="where-buy-tabs__nav fadeInUp">
      <ul class="where-buy-tabs__list" data-tabs="where-buy-tabs__contents">
        <li class="where-buy-tabs__item active">
          <button class="where-buy-tabs__tab btn btn_white">Сети магазинов</button>
        </li>
        <li class="where-buy-tabs__item">
          <button class="where-buy-tabs__tab btn btn_white">Маркетплейсы</button>
        </li>
      </ul>
    </nav>
  </div>
  <div class="where-buy-tabs__contents">
    <div class="where-buy-tabs__content active">
      <div class="where-buy-form fadeInRight">
        <div class="default-select" @click="inputCity=''">
          <select v-model="checkCountry" class="default-select__select">
            <option data-placeholder="true">Выберите вашу страну</option>
            <option v-for="(country, index) in citydata" :key="index" :value="country.NAME">{{ country.NAME }}</option>

          </select>
          <label class="where-buy-form__label default-input__label">Страна</label>
        </div>
        <div class="default-input default-input--icon b-list">
          <input @click="addScyleStyle()" v-model="inputCity" class="default-input__input b-list__input" type="text" placeholder="Начните вводить ваш город">
          <label class="where-buy-form__label default-input__label">Город</label>
          <div class="default-input__error">Введите, пожауйста, Ваш город</div>
          <div class="b-list__content scaleCustom" >
            <div v-if="inputCity !== null" class="b-list__list">
              <div v-for="(city, index) in checkCity" :key="index" @click="inputCity = city.name, inputIdCity = city.id ,updateMap(city.id), deleteScyleStyle()"  class="b-list__elem">{{ city.name }}</div>

            </div>
          </div>
        </div>
        <div class="where-buy-form__gps default-input"><a @click="getGeoposition()" class="default-input__label" href="#">Мое местоположение</a></div>
      </div>
      <aside class="where-buy-aside fadeInLeft">
        <div class="where-buy-aside__wrapper">
          <div class="where-buy-aside__header">
            <div class="where-buy-aside__title">
              Сети магазинов
              <br>
              в городе {{inputCity}}
            </div>
            <button class="where-buy-aside__close">
              <svg class="i-close" aria-hidden="true">
                <use xlink:href="./icons/icons.svg#svg-close"></use>
              </svg>
            </button>
          </div>
          <div class="where-buy-aside__items">
            <a @click="updateMap(inputIdCity)" :class="['where-buy-aside__item', {'active': checkShop===''}]"
               href="#"
               style="text-decoration: none">
            <span >Все сети</span>

            </a>
            <a v-for="(shop, index) in shops" :key="index" @click="filterShops(shop.idShop), checkShop=shop.idShop"
               :class="['where-buy-aside__item', {'active':checkShop === shop.idShop}]" href="#"
               style="text-decoration: none">
            <span v-if="!shop.logo">{{shop.name}}</span>
               <div v-else class="where-buy-aside__item-image">
              <picture>
                <img :src="shop.logo">
              </picture>
            </div>
            </a>


            </div>
        </div>
      </aside>
      <div class="where-buy-map">
        <div id="map" ref="map"></div>
      </div>
      <button class="where-buy-tabs__burger"></button>
      <div class="where-buy-tabs__mobile-filter">
        <div class="where-buy-tabs__mobile-filter-wrapper">
          <div class="where-buy-form where-buy-form_mobile">
            <div class="default-select" @click="inputCity=''"><select v-model="checkCountry"  class="default-select__select">
              <option  data-placeholder="true">Выберите вашу страну</option>
              <option  v-for="(country, index) in citydata" :key="index" :value="country.NAME">{{ country.NAME }}</option>

            </select><label class="where-buy-form__label default-input__label">Страна</label></div>
            <div class="default-input default-input--icon b-list">
              <input v-model="inputCity" @click="addScyleStyle()" class="default-input__input b-list__input"
                     type="text"
                     placeholder="Начните вводить ваш город">
              <label class="where-buy-form__label default-input__label">Город</label>
              <div class="default-input__error">Введите, пожауйста, Ваш город</div>
              <div class="b-list__content scaleCustomMob">
                <div v-if="inputCity !== null" class="b-list__list">
                  <div v-for="(city, index) in checkCity" :key="index" @click="inputCity = city.name, inputIdCity = city.id, updateMap(inputIdCity), deleteScyleStyle()" class="b-list__elem">{{ city.name }}</div>

                </div>
              </div>
            </div>
            <div class="where-buy-form__gps default-input"><a @click="getGeoposition(), closeMenu()" class="default-input__label"
                                                              href="#">Мое местоположение</a></div>
          </div>
          <aside class="where-buy-aside where-buy-aside_mobile">
            <div class="where-buy-aside__wrapper">
              <div class="where-buy-aside__header">
                <div class="where-buy-aside__title">выберите Сети магазинов
                  <br>
                  в городе {{inputCity}}
                </div>
                <button class="where-buy-aside__close">
                  <svg class="i-close"
                       aria-hidden="true">
                    <use xlink:href="./icons/new.svg#svg-close"></use>
                  </svg>
                </button>
              </div>
              <div class="where-buy-aside__items">
                <a @click="checkShop='', updateMap(inputIdCity) " :class="['where-buy-aside__item', {'active': checkShop===''}]"
                                                     href="#" style="text-decoration: none">
                <div class="where-buy-aside__item-text">Все сети</div>
              </a>
                <a v-for="(shop, index) in shops" :key="index" @click="checkShop = shop.idShop"
                   :class="['where-buy-aside__item',{'active':shop.idShop===checkShop}]" href="#"
                   style="text-decoration: none">

                    <div v-if="!shop.logo" class="where-buy-aside__item-text">
                    {{shop.name}}
                    </div>

                <div v-else class="where-buy-aside__item-image">
                  <img  :src="shop.logo">
                </div>
              </a>
               </div>
            </div>
          </aside>
          <button @click="filterShops(checkShop)" class="where-buy-tabs__mobile-filter-btn btn">Применить</button>
        </div>
      </div>
    </div>
    <div class="where-buy-tabs__content">
      <div class="where-buy-cards-slider swiper">
        <div class="where-buy-cards-slider__wrapper swiper-wrapper">
            <a v-for="(market, index) in marketdata.NAME" :key="index" class="where-buy-cards-slider__slide swiper-slide" :href="marketdata.LINK[index]" target="_blank">
            <div class="where-buy-cards-slider__image">
              <img :src="marketdata.LOGO[index]" :alt="market">
            </div>
            <div class="where-buy-cards-slider__image-link"></div>
            </a>
        </div>
      </div>
    </div>
  </div>
  <div class="where-buy__particle particle"></div>
</template>

<script>
export default {
  name : "Where-Buy",

  data() {
    return {

      checkCountry: "Россия",
      inputCity: "Челябинск",
      dataInputCity: "",
      checkShops: "",
      checkShop: "",
      inputIdCity: "63",
      center: [ 55.1718897, 61.3054095],
      points:  []
    }
  },
  props: {
    citydata: {
      type: Array,
      required: false
    },
    shopsdata: {
      type: Array,
      required: true
    },
    ipuser:{
      type: String,
      required: true
    },
    marketdata:{
      type: Array,
      required: true
    }

  },
  computed: {
    checkCity(){
      let result = null;
      let resultCity= [];
      let i = 0;
      if(this.checkCountry !== ""){

        this.citydata.forEach(
            (element) =>
            {
              if( element.NAME === this.checkCountry )
                {
                  if( this.inputCity !== "" )
                    {
                      i = 0;
                      //result =  element.city.filter(element = element.toLowerCase().indexOf(this.formData.city.toLowerCase()) !== -1)// eslint-disable-line;
                      let cityData = element.CHILD;
                      // cityData.forEach(cityEl => {
                      //   console.log(cityEl.name);
                      // })

                      result = cityData.filter(el => el.NAME.toLowerCase().indexOf(this.inputCity.toLowerCase()) !== -1)// eslint-disable-line

                      result.forEach(element =>
                      {
                        resultCity[ i ] ={};
                        resultCity[ i ].name =element.NAME;
                        resultCity[ i ].id =element.ID;
                        //resultCity [ i ].points=element.shops;
                        i++;
                      })

                    }
                  else
                    {
                      i = 0;
                      result=element.CHILD;
                      result.forEach(element =>
                      {
                        resultCity[ i ] ={};
                        resultCity[ i ].name =element.NAME;
                        resultCity[ i ].id =element.ID;

                        i++;
                      });
                    }

                }


            } )
      }
      return resultCity
    },
    shops(){
      let allShops = ['1','2'];
      let filteredShop = [];
      let i = 0;
      if(this.points.ID_SHOPS)
        {
          allShops = this.points.ID_SHOPS;
        }
      const getUniqueShops = (arr) => {
        return arr.filter((el, ind) => ind === arr.indexOf(el));
      };
      this.shopsdata.ID_SHOP.forEach((shop,index) => {getUniqueShops(allShops).forEach( (uniqShop) => {if(shop == uniqShop)
        {
           // filteredShops[i].logo = this.shopsdata.LOGO[index];
          filteredShop[i] ={};
          filteredShop[i].idShop = this.shopsdata.ID_SHOP[index];
          filteredShop[i].logo = this.shopsdata.LOGO[index];
          filteredShop[i].name = this.shopsdata.NAME[index];
          //console.log(this.shopsdata.LOGO[index]);
          i++;
      }
      } )})
      //console.log(filteredShop);
      return filteredShop;
    }
  },

  created() {
    /* eslint-disable */
    ymaps.ready(this.initMap);
  },
  methods: {
    initMap() {
      this.map = new ymaps.Map(this.$refs.map, {
        center: this.center,
        zoom: 11,
        controls: []
      }, {maxZoom: 18});

      this.map.controls.add('zoomControl');

      this.clusterer = new ymaps.Clusterer({

        //preset: 'islands#invertedRedClusterIcons',
        // Зададим макет метки кластера.

        clusterIconLayout: ymaps.templateLayoutFactory.createClass('<a style="align-items: center;\n' +
                                                                    '\tbackground-color: var(--color-dark);\n' +
                                                                    '\tborder-radius: 55%;\n' +
                                                                    '\t/* bottom: 100px; */\n' +
                                                                    '\tcolor: var(--color-white);\n' +
                                                                    '\tdisplay: flex;\n' +
                                                                    '\theight: 2.5rem;\n' +
                                                                    '\tjustify-content: center;\n' +
                                                                    '\t/* left: 20px; */\n' +
                                                                    '\t/* position: absolute; */\n' +
                                                                    '\ttext-decoration: underline;\n' +
                                                                    '\ttransition: background-color .3s;\n' +
                                                                    '\t-webkit-user-select: none;\n' +
                                                                    '\tuser-select: none;\n' +
                                                                    '\twidth: 2.5rem;"  href="#">{{ properties.geoObjects.length }}</a>'),
        // Чтобы метка была кликабельной, переопределим ее активную область.
        clusterIconShape: {
          type: 'Rectangle',
          coordinates: [[0, 0], [40, 40]]
        },
        groupByCoordinates: false,
        clusterOpenBalloonOnClick: false,
        clusterDisableClickZoom: false,
        clusterHideIconOnBalloonOpen: true,
        geoObjectHideIconOnBalloonOpen: true
      })

      let clusterIconLayoutHover = ymaps.templateLayoutFactory.createClass('<a style="align-items: center;\n' +
                                                           '\tbackground-color: var(--color-hover);\n' +
                                                           '\tborder-radius: 55%;\n' +
                                                           '\t/* bottom: 100px; */\n' +
                                                           '\tcolor: var(--color-white);\n' +
                                                           '\tdisplay: flex;\n' +
                                                           '\theight: 2.5rem;\n' +
                                                           '\tjustify-content: center;\n' +
                                                           '\t/* left: 20px; */\n' +
                                                           '\t/* position: absolute; */\n' +
                                                           '\ttext-decoration: underline;\n' +
                                                           '\ttransition: background-color .3s;\n' +
                                                           '\t-webkit-user-select: none;\n' +
                                                           '\tuser-select: none;\n' +
                                                           '\twidth: 2.5rem;"  href="#">{{ properties.geoObjects.length }}</a>')

      let clusterIconLayout = ymaps.templateLayoutFactory.createClass('<a style="align-items: center;\n' +
                                                                           '\tbackground-color: var(--color-dark);\n' +
                                                                           '\tborder-radius: 55%;\n' +
                                                                           '\t/* bottom: 100px; */\n' +
                                                                           '\tcolor: var(--color-white);\n' +
                                                                           '\tdisplay: flex;\n' +
                                                                           '\theight: 2.5rem;\n' +
                                                                           '\tjustify-content: center;\n' +
                                                                           '\t/* left: 20px; */\n' +
                                                                           '\t/* position: absolute; */\n' +
                                                                           '\ttext-decoration: underline;\n' +
                                                                           '\ttransition: background-color .3s;\n' +
                                                                           '\t-webkit-user-select: none;\n' +
                                                                           '\tuser-select: none;\n' +
                                                                           '\twidth: 2.5rem;"  href="#">{{ properties.geoObjects.length }}</a>')


      this.clusterer.events
          // Можно слушать сразу несколько событий, указывая их имена в массиве.
          .add(['mouseenter', 'mouseleave'], function (e) {
            var target = e.get('target'),
                type = e.get('type');
            if (typeof target.getGeoObjects != 'undefined') {
              // Событие произошло на кластере.
              if (type == 'mouseenter') {
                target.options.set('clusterIconLayout', clusterIconLayoutHover);
              } else {
                target.options.set('clusterIconLayout', clusterIconLayout);
              }
            }
          });

      // Создание макета балуна на основе Twitter Bootstrap.
      this.MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
          '<div class="where-buy-map__pin-content active">' +
          '            <div class="where-buy-map__pin-content-wrapper">' +
          '              <div class="where-buy-map__pin-info" style="min-width: 18rem;">' +
          '$[[options.contentLayout]]' +
          '              </div>' +
          '              <button class="where-buy-map__pin-close">' +
          '                X' +
          '              </button>' +
          '            </div>' +
          '          </div>'   , {
            build:  function () {
              this.constructor.superclass.build.call(this);
              this._$element = $('.where-buy-map__pin-content', this.getParentElement());
              this._$element.find('.where-buy-map__pin-close').on('click', $.proxy(this.onCloseClick, this));

            },

            /**
             * Используется для автопозиционирования (balloonAutoPan).
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
             * @function
             * @name getClientBounds
             * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
             */
            getShape: function () {


              var position = this._$element.position();

              return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                [position.left, position.top], [
                  position.left + this._$element[0].offsetWidth,
                  position.top + this._$element[0].offsetHeight + this._$element.find('.where-buy-map__pin-close')[0].offsetHeight
                ]
              ]));
            },
            onCloseClick: function (e) {
              e.preventDefault();

              this.events.fire('userclose');
            }
          }),

          this.MyBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
              '<div class="where-buy-map__pin-title">$[properties.balloonHeader]</div>'+
              '<adress class="where-buy-map__pin-address">$[properties.balloonContent]</address>'

          ),


      this.getPointOptions = function () {
        return {
          preset: 'islands#blueStretchyIcon',

        };
      }
      this.updateMap(this.inputIdCity);
    },
        updatePoints(id)
      {
        const formData=new FormData();
        formData.set('city_id', id);

        fetch("/local/api/requestCity.php",{
          method : "POST",
          body: formData
        })
            .then(response => response.json())
            .then(result =>
            {
              this.points = result;
              //coords = result.COORDS.map(el=>el.map(elem=>Number(elem)));
              //console.log(result);
              //console.log(this.points);

            })
      },

    updateMap(id, updatePoints = true) {
      //console.log(id);
      if(updatePoints)
        {
          this.updatePoints(id);
        }
      this.checkShop='';
      setTimeout(()=> {
        if(this.checkShop === '')
          {
            this.getPointOptions = function () {
              return {
                //preset: 'islands#blueStretchyIcon',
                //iconLayout: squareLayout,
                // Своё изображение иконки метки.
                //iconImageHref: 'images/myIcon.gif',
                balloonShadow: false,
                balloonLayout: this.MyBalloonLayout,
                balloonContentLayout: this.MyBalloonContentLayout,
                balloonPanelMaxMapArea: 0,
                iconLayout: 'default#image',
                iconImageHref: '/local/templates/xpage/img/Map_Pin.png',
                iconImageSize: [40, 40],
                iconImageOffset: [-20, -20]

              };
            }

            setTimeout(()=>
            {
              this.map.panTo(this.points.COORDS[0].map(el=>Number(el)));
              if(this.geoObjects){
                this.clusterer.remove(this.geoObjects);
              }

              this.geoObjects     =[];
              for( let i=0, len=this.points.COORDS.length; i < len; i++ )
                {
                  this.geoObjects[ i ]=new ymaps.Placemark(this.points.COORDS[ i ], {
                    balloonHeader: this.points.NAME[ i ],
                    balloonContent: this.points.ADDRESS[ i ],
                  }, this.getPointOptions());
                }
              this.clusterer.add(this.geoObjects);
              //this.clusterer.add(this.marks);
              this.map.geoObjects.add(this.clusterer);
            }, 300)
          }
      }, 500)


    },

    filterShops(id)
      {
        if(id !== '')
        {
        let length = this.points.COORDS.length;
        //console.log(this.points.COORDS);
        let result ={};
        result.coords = [];
        result.name = [];
        result.address = [];

            for(let i = 0; i < length; i++)
              {
                if(this.points.ID_SHOPS[i] == id)
                  {

                    result.coords.push(this.points.COORDS[i]);
                    result.name.push(this.points.NAME[i])
                    result.address.push(this.points.ADDRESS[i])
                    //console.log(this.points.COORDS[i]);
                  }
              }
            //console.log(result);
            this.clusterer.remove(this.geoObjects);
            this.getPointOptions = function () {
              return {
                //preset: 'islands#blueStretchyIcon',
                //iconLayout: squareLayout,
                // Своё изображение иконки метки.
                //iconImageHref: 'images/myIcon.gif',
                balloonShadow: false,
                balloonLayout: this.MyBalloonLayout,
                balloonContentLayout: this.MyBalloonContentLayout,
                balloonPanelMaxMapArea: 0,
                iconLayout: 'default#image',
                iconImageHref: '/local/templates/xpage/img/Map_Pin.png',
                iconImageSize: [40, 40],
                iconImageOffset: [-20, -20]

              };
            }
            this.geoObjects = [];
            for(let i = 0, len = result.coords.length; i < len; i++)
              {
                this.geoObjects[ i ]=new ymaps.Placemark(result.coords[ i ], {
                  balloonHeader: result.name[ i ],
                  balloonContent: result.address[ i ],
                }, this.getPointOptions());
              }
            this.clusterer.add(this.geoObjects);
            //this.clusterer.add(this.marks);
            this.map.geoObjects.add(this.clusterer);
            this.map.setBounds(this.map.geoObjects.getBounds());

          }



      },
    addScyleStyle()
      {
        document.querySelector('.scaleCustom').style.transform = 'scaleY(1)';
        document.querySelector('.scaleCustomMob').style.transform = 'scaleY(1)'
      },
    deleteScyleStyle()
      {
        document.querySelector('.scaleCustom').style.transform = 'scaleY(0)';
        document.querySelector('.scaleCustomMob').style.transform = 'scaleY(0)'
      },

    getGeoposition()
      {
       this.checkShop='';
        if(this.ipuser)
          {
            const formData=new FormData();
            formData.set('ip_user', this.ipuser);

            fetch("/local/api/requestGeoposition.php",{
              method : "POST",
              body: formData
            })
                .then(response => response.json())
                .then(result =>
                {
                  //this.points = result;
                  //coords = result.COORDS.map(el=>el.map(elem=>Number(elem)));
                  console.log(result);
                  if(result.location)
                    {
                      let userCity = result.location.data.city;
                      let userCountry = result.location.data.country;
                      let userGeoLat = Number(result.location.data.geo_lat);
                      let userGeoLon = Number(result.location.data.geo_lon);

                      this.citydata.forEach(element =>
                      {
                        element.CHILD.forEach((city, index) =>
                        {
                          if(city.NAME.trim().toLowerCase() === userCity.trim().toLowerCase())
                            {
                              //console.log(userCity);
                              document.querySelector('.ss-single').innerHTML = userCountry;
                              this.checkCountry = userCountry;
                              this.inputCity = userCity;
                              let idCityUser=element.CHILD[ index ].ID;
                              setTimeout(()=> {
                                this.updateMap(idCityUser);
                              }, 1000)

                            }

                      })
                    })
                      this.map.panTo([userGeoLat, userGeoLon]);
                  //console.log(this.points);
                }
          })
          }

  },
    closeMenu()
      {
        let event = new Event("click");
        let success = document.querySelector('.where-buy-tabs__burger');
        setTimeout(()=> {
          success.dispatchEvent(event);// eslint-disable-line
        }, 300)

      }
  }
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 100%;
}
</style>